import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _AggregationTable;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import t from '@instructure/quiz-i18n/es/format-message';
import { Table } from '@instructure/ui-table';
import { onlyAggregatePropType } from '../../../../common/propTypes';
import PropTypes from 'prop-types';
import { IconCheckSolid, IconXSolid, IconNoSolid, IconGradebookSolid } from '@instructure/ui-icons';
import { jsx } from '@instructure/emotion';
import generateComponentTheme from './theme';
import generateStyle from './styles';
import { Text } from '@instructure/ui-text';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
var noAnswerKey = 'noAnswer';
var incorrectKey = 'incorrect';
var correctKey = 'correct';
var gradedKey = 'graded';
export var AggregationTable = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_AggregationTable = /*#__PURE__*/function (_Component) {
  function AggregationTable() {
    var _this;
    _classCallCheck(this, AggregationTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AggregationTable, [].concat(args));
    _defineProperty(_this, "renderHeaderRow", function () {
      var popover = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var itemId = _this.props.itemId;
      var answerHeaderId = "answer-frequency-summary-aggregate-answer-".concat(itemId);
      var respondentsHeaderId = "answer-frequency-summary-aggregate-respondents-".concat(itemId);
      var percentageHeaderId = "answer-frequency-summary-aggregate-percentage-".concat(itemId);
      return jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        id: answerHeaderId
      }, jsx("span", {
        css: _this.props.styles.firstHeaderCell
      }, t('Result'))), jsx(Table.ColHeader, {
        id: respondentsHeaderId,
        textAlign: "center"
      }, t('Respondents')), jsx(Table.ColHeader, {
        id: percentageHeaderId,
        textAlign: "center"
      }, t('Percentage'))));
    });
    _defineProperty(_this, "renderRow", function (key, icon, label, count, percentage) {
      var backgroundColor = _this.props.styles["".concat(key, "Background")];
      var concatenatedPercentage = "".concat(percentage, "%");
      return jsx(Table.Row, {
        key: key
      }, jsx(Table.RowHeader, {
        themeOverride: {
          padding: '0px'
        }
      }, jsx(Flex, {
        direction: "row",
        alignItems: "center"
      }, jsx(Flex.Item, {
        width: "46px",
        textAlign: "center",
        align: "stretch"
      }, jsx("div", {
        css: [_this.props.styles.iconWrapper, backgroundColor]
      }, icon)), jsx(Flex.Item, {
        shouldShrink: true
      }, jsx("div", {
        "data-testid": "label-wrapper",
        css: _this.props.styles.labelWrapper
      }, jsx(Text, null, label))))), jsx(Table.Cell, {
        themeOverride: {
          padding: '0px'
        },
        textAlign: "center"
      }, jsx(Text, null, count)), jsx(Table.Cell, {
        themeOverride: {
          padding: '0px'
        },
        textAlign: "center"
      }, jsx(Text, null, concatenatedPercentage)));
    });
    _defineProperty(_this, "gradedExist", function () {
      var graded = _this.props.answerSummary.graded;
      return !!graded;
    });
    _defineProperty(_this, "correctExist", function () {
      var aggregate = _this.props.answerSummary.aggregate;
      return !!(aggregate !== null && aggregate !== void 0 && aggregate.correct);
    });
    _defineProperty(_this, "incorrectExist", function () {
      var aggregate = _this.props.answerSummary.aggregate;
      return !!(aggregate !== null && aggregate !== void 0 && aggregate.incorrect);
    });
    _defineProperty(_this, "noAnswerExist", function () {
      var no_answer = _this.props.answerSummary.no_answer;
      return !!no_answer;
    });
    _defineProperty(_this, "renderCorrect", function () {
      var aggregate = _this.props.answerSummary.aggregate;
      var correct = aggregate.correct;
      var correctCount = correct.count || 0;
      var correctPercentage = correct.percentage || 0;
      return _this.renderRow(correctKey, jsx(IconCheckSolid, null), t('Correct'), correctCount, correctPercentage);
    });
    _defineProperty(_this, "renderGraded", function () {
      var graded = _this.props.answerSummary.graded;
      var gradedCount = graded.count || 0;
      var gradedPercentage = graded.percentage || 0;
      return _this.renderRow(gradedKey, jsx(IconGradebookSolid, null), t('Graded'), gradedCount, gradedPercentage);
    });
    _defineProperty(_this, "renderIncorrect", function () {
      var aggregate = _this.props.answerSummary.aggregate;
      var incorrect = aggregate.incorrect;
      var incorrectCount = incorrect.count || 0;
      var incorrectPercentage = incorrect.percentage || 0;
      return _this.renderRow(incorrectKey, jsx(IconXSolid, null), t('Incorrect'), incorrectCount, incorrectPercentage);
    });
    _defineProperty(_this, "renderNoAnswer", function () {
      var no_answer = _this.props.answerSummary.no_answer;
      var noAnswerCount = no_answer.count || 0;
      var noAnswerPercentage = no_answer.percentage || 0;
      return _this.renderRow(noAnswerKey, jsx(IconNoSolid, null), t('No response'), noAnswerCount, noAnswerPercentage);
    });
    _defineProperty(_this, "getColorProfile", function () {
      var colorProfile;
      var correctIncorrectNoAnswerGraded = _this.gradedExist() && _this.noAnswerExist() && _this.correctExist() && _this.incorrectExist();
      var correctIncorrectNoAnswer = !_this.gradedExist() && _this.noAnswerExist() && _this.correctExist() && _this.incorrectExist();
      var onlyNoAnswer = _this.noAnswerExist() && !_this.gradedExist() && !_this.correctExist() && !_this.incorrectExist();
      if (correctIncorrectNoAnswer) {
        colorProfile = 'correctIncorrectNoanswer';
      } else if (correctIncorrectNoAnswerGraded) {
        colorProfile = 'correctIncorrectNoanswerGraded';
      } else if (onlyNoAnswer) {
        colorProfile = 'onlyNoanswer';
      } else {
        colorProfile = 'correctIncorrect';
      }
      return colorProfile;
    });
    _defineProperty(_this, "render", function () {
      var popover = !_this.noAnswerExist();
      var tableStyles = [_this.props.styles.collapsingTable, _this.props.styles[_this.getColorProfile()]];
      return jsx("div", {
        css: tableStyles
      }, jsx(Table, {
        caption: t('Answer Frequency Summary Aggregates')
      }, _this.renderHeaderRow(popover), jsx(Table.Body, null, _this.correctExist() && _this.renderCorrect(), _this.gradedExist() && _this.renderGraded(), _this.incorrectExist() && _this.renderIncorrect(), _this.noAnswerExist() && _this.renderNoAnswer())));
    });
    return _this;
  }
  _inherits(AggregationTable, _Component);
  return _createClass(AggregationTable);
}(Component), _defineProperty(_AggregationTable, "displayName", 'AggregationTable'), _defineProperty(_AggregationTable, "componentId", "Quizzes".concat(_AggregationTable.displayName)), _defineProperty(_AggregationTable, "propTypes", {
  itemId: PropTypes.number.isRequired,
  answerSummary: onlyAggregatePropType.isRequired,
  styles: PropTypes.object
}), _AggregationTable)) || _class);